  import { Component, OnDestroy, TemplateRef, ViewChild, ElementRef, ViewChildren, QueryList, forwardRef, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap, NavigationExtras } from '@angular/router';
import { AlertService } from '../_infrastructure/Alerts/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { mergeMap, map, filter, tap } from 'rxjs/operators';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalService } from '../_infrastructure/Modal/ModalService';
import { SystemInformationService } from '../_infrastructure/SystemInformation/SystemInformationService';
import { ICardComponentInjectionToken } from '../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { isNullOrUndefined } from '../_infrastructure/objectUtils';
import { LoadingMaskService } from '../_infrastructure/LoadingMask/LoadingMaskService';
import { SecurityService } from '../_infrastructure/Security/SecurityService';
import { StepDetailsService } from '../_infrastructure/StepDetailsService/StepDetailsService';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { LogService } from '../_infrastructure/log/LogService';
import { LogType } from '../../models/const.LogModelVM';
import { CacheService } from '../_infrastructure/Cache/CacheService';
import { EscolhaVinculo1RadioOptionElement, EscolhaVinculo2RadioOptionElement, PerguntaConcorda1RadioOptionElement } from './FakeChildClassRadioOption';
import { DocumentVMExtension } from '../workflows/cards/Documentation/IDocumentation';
import { VinculosAndIndexVM } from './vinculos/vinculos-list.component';
import { DocumentsHandlerService } from '../_infrastructure/Documents/DocumentHandlerService';
import { flatten, forEach } from 'lodash';
import { CommonData } from '../_infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../models/const.DomainCodes';
import * as _ from 'lodash';
import { NgForm, ControlContainer, FormGroupName, FormGroup, FormControl } from '@angular/forms';
import DateHelpers from '../_infrastructure/DateHelpers';
import { CommonDataService } from '../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../_infrastructure/Utils/UtilsService';
import { SessionStorageService } from '../_infrastructure/SessionStorageService/SessionStorageService';

enum ServicoResponsavelScenarios {
  Ativo = 1,
  InativoNaoIntegrado = 2,
  InativoIntegrado = 3,
  AtivoIntegradoExtinto = 4,
  AtivoIntegradoAtivo = 5,
  NaoInscritoOuSemSubsAtivos = 6
}

@Component({
    selector: 'workflow-instance-creator',
    templateUrl: './workflow-instance-creator.component.html',
    styleUrls: ['./workflow-instance-creator.component.scss'],
    standalone: false
})

export class WorkflowInstanceCreatorComponent implements OnDestroy {
  public isCollapsed: boolean = true;
  modalRef: BsModalRef;
   
  @ViewChild('withData') withData: TemplateRef<any>;
  @ViewChild('revisionNeeded') revisionNeededModal: TemplateRef<any>;
  @ViewChild('noRegistration') noRegistration: TemplateRef<any>;


  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];

  //BUSINESS
  public workflowCode: string;
  public childWorkflow: string;
  public subscriberNumber: number;
  public forceNew: boolean;
  public workflowInstanceId: number;
  public stepCode: string;
  public exists: boolean;
  public pediObri: boolean;
  public estaRegi: boolean;
  public revisionNeeded: boolean;
  public serviceManifestRejectSucessfully: boolean;
  public isService: boolean;
  public serviceCode: string;
  public atendimento: string;
  public tipoUtilizador: string;
  public isExSubscritor: boolean;
  public cgaSubmitedDocuments: boolean = false;
  public isNSI: boolean = false;
  public finalService: models.VinculoServicoVM;
  public sOrigem: number;
  //OPTIONS
  public workflowDefinition: models.WorkflowInformationVM = <models.WorkflowInformationVM>{};
  public childWorkFlows: models.WorkflowInformationVM[];
  public childWorkFlowsVoluntaria: models.WorkflowInformationVM[];
  public childWorkFlowsObrigatoria: models.WorkflowInformationVM[];
  public optDraft: string;
  private cgaDirectaAddress: string;
  public dropdownListaMotivosEXAP: models.Options[] = [] as models.Options[];
  public dropdownListaMotivosAnnulation: models.Options[] = [] as models.Options[];
  //NAVIGATION
  public currentStep: number = -1;
  public currentServiceScenario: number = 1;
  public Scenarios: typeof ServicoResponsavelScenarios = ServicoResponsavelScenarios;
  /*
   * 0 : Escolha subscritor
   * 1 + Pedido PEDI001 : Escolha de fundamento
   * 1 + Pedido PEDI005|PEDIDO008 : PRESTAGE Preenchimento
   * 2 : Ecra envio pedido para subscritor 
   * 99 : SERVIÇO APOSENTAÇÃO EX SUBSCRITOR MANIFESTO FUNDAMENTOS
   * 98 : SERVIÇO APOSENTAÇÃO EX SUBSCRITOR MANIFESTO
   * 97 : SERVIÇO APOSENTAÇÃO EX SUBSCRITOR MANIFESTO REJEICAO
   * 96 : SERVIÇO APOSENTAÇÃO EX SUBSCRITOR - ANULACAO
   */
  public steps: string[] = ['step1', 'step2', 'step3'];
  //PERMISSIONS
  public isAtendimento: boolean;

  @ViewChild('cgaGetFileForm', { read: ElementRef }) cgaGetFileForm: ElementRef;
  @ViewChild('cgaGetFileFormInput', { read: ElementRef }) cgaGetFileFormInput: ElementRef;
  public domain: string;
  public allowDelete: boolean = true;
  //PIT 40803
  public destinoRouter: string;

  // #region CONTAGEM TEMPO
  // NEW CODE CONTAGEM TEMPO
  public tipoPedidoDescricao: string = " um Pedido de Aposentação ";
  public fakeChildWorkFlows: Partial<models.WorkflowInformationVM>[] = [
    {
      title: "Sim",
      description: "Contagem de tempo a pedido do subscritor.",
      workflowCode: "PEDI0020A",
      workFlowHelpLink: "633",
      workflowExternalLink: "",
      workflowTargetAudience: "Civil | Militar | Militarizado",
      mandatory: false,
      isWorkflowMandatory: "N",
      // here we use this as a temp value
      isLogActive: "N",
      subTitle :null
    } as Partial<models.WorkflowInformationVM> ,
    {
      title: "Não",
      description: "Contagem de tempo oficiosa.",
      workflowCode: "PEDI0020B",
      workFlowHelpLink: "633",
      workflowExternalLink: "",
      workflowTargetAudience: "Civil | Militar | Militarizado",
      mandatory: false,
      isWorkflowMandatory: "S",
      isLogActive: "N",
      subTitle: "(contagem de tempo oficiosa a pedido da CGA)"
    } as Partial<models.WorkflowInformationVM>,
  ]

  // #endregion CONTAGEM TEMPO


  // #region EXSUBSCRITORES
  // Pre Stage
  public preStageStep: number = null;
  public motivoRejeicaoManifestoEx: string;
  public isReadonly: boolean = false;
  public isFromCGA: boolean = false;
  public isAllowPersonalData: boolean = false;
  public choosenVinculoReset: boolean = false;

  public expandedRowIndex: number = null;

  private preStageRoot: models.StepPrestageRootVM = {} as models.StepPrestageRootVM;
  private preStageForm: models.StepPrestageVM = {} as models.StepPrestageVM;
  
  public subscriberServices: Partial<models.VinculoServicoVM> []= [];

  public ExSubscritorPerguntaCGAFim: boolean = null;
  public yesNoDomain = [true, false];
  public respostaExSubscritor: boolean = null;
  public cgaJustification: string = null;  
  public cgaJustificationFileExist: string = null;
  public bAnnulationExtraDesc: boolean = false;


  @ViewChild("motivoCode") motivoForm: FormControl;

  @ViewChild("cgaWorkflowForm") myForm;
  noOptionService: Partial<models.VinculoServicoVM> = {
    designacao: "Nenhuma das opções anteriores",
    distrito: null,
    localidade: null,
    chaveServico: "-1",
    estado: null
  };

  public documentsList: models.DocumentVM[] = [];

  
  private mainSubscription: Subscription = new Subscription()
  // #endregion EXSUBSCRITORES CONTAGEM TEMPO


  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private router: Router, private alertService: AlertService,
    private translate: TranslateService, private modalService: BsModalService, private modalS: ModalService,
    private systemInfo: SystemInformationService, private loadingMaskService: LoadingMaskService, private translateService: TranslateService,
    private securityService: SecurityService, private stepDetailsService: StepDetailsService, private logService: LogService,
    private commonDataService: CommonDataService, private utilsService: UtilsService,
    private cacheService: CacheService, private documentService: DocumentsHandlerService, private sessionStorageService: SessionStorageService) {


    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.identificationType
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.documentTypes = this.utilsService.getDomainOfDomains(DomainCodes.identificationType, results).dimensions;
      })
    );


    this.activeRoute.paramMap.subscribe((params: ParamMap) => {


  
      this.workflowCode = params.get('code');
      this.workflowInstanceId = params.get('instanceId') != null ? parseInt(params.get('instanceId')) : null;
      this.currentStep = params.get('currentStep') != null ? parseInt(params.get('currentStep')) : null;

      this.atendimento = (this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null);
      this.isAtendimento = this.atendimento == 'A';

      this.serviceCode = this.atendimento == "A" ? null : this.securityService.userDetails.service;

      this.tipoUtilizador = (this.atendimento == "A" ? "A" : ((!isNullOrUndefined(this.serviceCode)) ? "S" : "U"));
      this.isExSubscritor = this.workflowCode.indexOf('PEDI008') == -1 && this.workflowCode.indexOf('PEDI005') == -1 ? false : true;
      this.isService = this.tipoUtilizador == "S" ? true : false;
      var sn = params.get('subscriberNumber');
      if (sn) {
        this.subscriberNumber = parseInt(sn);
      } else {
        if (!this.isAtendimento && !this.isService) {
          this.subscriberNumber = parseInt(this.securityService.userDetails.utente);
        }
      }

      this.http.get('api/Workflow/ValidaOrigemMGPA', { params: { workflowInstanceID: this.workflowInstanceId } }
      ).subscribe((res: any) => {
        this.sOrigem = res;
      }, error => {
        this.loadingMaskService.setShowLoading(false);
        this.alertService.error('Generic.GlobalError');
        return false;
      });
      //INITIALIZE
      //TODO melhorar este codigo? haverá maneira de sair destes ifs para ver se é ex sub? com rxjs?
    
      if ((!this.isExSubscritor && this.currentStep != 96) || (this.workflowCode == 'PEDI008B' && this.currentStep != 96)) {
        this.currentStep = this.workflowInstanceId ? 2 : 0
      }
      else {
        this.stepDetailsService.newWorkFlowCode(this.workflowCode);
        
        if (this.currentStep == 96) {
          this.loadingMaskService.setShowLoading(true);
          this.loadAnulacaoMotivosDropdown();
        }
        else {
          this.loadingMaskService.setShowLoading(true, true, null);
          if ((this.workflowInstanceId == null || this.workflowInstanceId == undefined) && !this.isService){
            this.CreatePreStageInstance();
          }
          else {
            this.loadWorkflowInstance(this.workflowInstanceId);
          }
        }

        this.loadWorkflowDetails();

      }
    });
    this.systemInfo.loadCurrentSystemInformation().subscribe(result => {
      this.cgaDirectaAddress = result.cgaDirecta;
      this.domain = this.securityService.userDetails.refererDomain + result.fileTransfer;
      this.isNSI = result.proveniencia == "NSI";
    })

  }


  ngOnInit() {
    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];

    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      //const oriValue = JSON.parse(dadosOrigem);

      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
  }
  // PIT 40803 \\

  public loadWorkflowDropdowns() {
    return this.http.get<models.WorkflowDropdownsVM>('api/Workflow/LoadWorkflowDropdowns', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });
  }

  public onAutorizaChange(autoriza: any) {
    this.preStageForm.preStageInfo.allowPersonalData = autoriza.target.value == "true" ? "S" : "N";
  }

  public onDeleteWorkflow(event: Event) {
    event.preventDefault();
    //DELETE WORKFLOW
    var confirmMessage = "Workflow.ConfirmDeleteWorkflowGeneric";
    var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: confirmMessage };
    this.modalS.showModals([confirmDeleteModal]).subscribe(result => {
      if (!result) return;

      this.loadingMaskService.setShowLoading(true, false);
      return this.http.post<models.WorkflowStatusVM>('api/Workflow/TerminateWorkflowInstance', null, { params: { workflowInstanceId: this.workflowInstanceId } }
      ).subscribe(res => {
        this.loadingMaskService.setShowLoading(false);
        if (res.stateCode == 'E') {
          this.alertService.error(res.message);
          return;
        }
        // The next line is telling header component to hide the help button;
        this.stepDetailsService.workFlowCode.next(null);
        const messagemApagado = "WorkflowSearch.TerminatedWorkflowGeneric";
        const navigationExtras: NavigationExtras = { state: { data: messagemApagado, code: 'OK' } };

        // PIT 40803 \\
        const validOption = ['/instancebrowser', '/workflowSearch'];
        const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

        if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
          //const oriValue = JSON.parse(dadosOrigem);
          this.destinoRouter = dadosOrigem.origemDoAcesso;          
        }
        else {
          this.destinoRouter = 'workflowSearch';
        }
        // PIT 40803 \\

        this.router.navigate([this.destinoRouter], navigationExtras);
      },
        error => this.loadingMaskService.setShowLoading(false)
      )
    });
  }

  public onAnnulationWorkflow() {
    //DELETE WORKFLOW
    if (
      (this.annulationMotive == null || this.annulationMotive == "" || this.annulationMotive == undefined || this.annulationMotive == "undefined") ||
      (this.dropdownListaMotivosAnnulation.find(m => m.value == this.annulationMotive)?.type == "1" && (this.annulationMotiveOtherDesc == "" || this.annulationMotiveOtherDesc == null || this.annulationMotiveOtherDesc.length < 10))
    ) {
      let modal = <models.BaseModalVM>{ isError: true, message: "Não é possível avançar com o pedido, existe informação em falta. Por favor reveja a informação inserida." };
      this.modalS.showModals([modal]).subscribe(result => console.log(result));
      return false;
    }
  
    var confirmMessage = "Workflow.ConfirmDeleteWorkflowGeneric";
    var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: confirmMessage };
    this.modalS.showModals([confirmDeleteModal]).subscribe(result => {
      if (!result) return;

      this.loadingMaskService.setShowLoading(true, false);
      //Como este ecrã não processa o XML total, apenas processa o Prestage, é necessário ir buscar o xml TOTAL
      this.http.get<models.WorkflowInstanceVM>('api/Workflow/LoadWorkflowInstance', { params: { workflowInstanceId: this.workflowInstanceId } }
      ).subscribe((wfi: models.WorkflowInstanceVM) => {

        if (
          ((wfi.workflowCode.indexOf('PEDI008') != -1 || wfi.workflowCode.indexOf('PEDI005') != -1)
            && this.securityService.userDetails.informationGroups.includes("PGPS")
            //&& (wfi.formData['stepPreStage']['preStageInfo']['isSentCGA'] == "true" || this.sOrigem == 1)
          )
          || (wfi.workflowCode.indexOf('PEDI0020B') != -1 && this.securityService.userDetails.informationGroups.includes("PGPS") && this.sOrigem == 1) //CTO Normal criada via MGPA
        ) {
          wfi.formData.StepServiceInfo['ServiceAnnulation']['annulationMotive'] = this.dropdownListaMotivosAnnulation.find(m => m.value == this.annulationMotive).description;
          wfi.formData.StepServiceInfo['ServiceAnnulation']['annulationMotiveDescServ'] = this.dropdownListaMotivosAnnulation.find(m => m.value == this.annulationMotive)?.type == "1" ? ": " + this.annulationMotiveOtherDesc : "";

          this.http.post<models.WorkflowStatusVM>('api/Workflow/SaveWorkflowInstance', wfi.formData, { params: { workflowInstanceId: this.workflowInstanceId } })
            .subscribe((wf: models.WorkflowStatusVM) => {
              this.alertService.clear();
              if (wf.stateCode == <string>"OK") {
                this.http.post('api/Workflow/TerminateWorkflowInstance', null, { params: { workflowInstanceId: this.workflowInstanceId } }
                ).subscribe(() => {
                  this.loadingMaskService.setShowLoading(false);
                  // The next line is telling header component to hide the help button;
                  this.stepDetailsService.workFlowCode.next(null);
                  const messagemApagado = "WorkflowSearch.TerminatedWorkflowGeneric";
                  const navigationExtras: NavigationExtras = { state: { data: messagemApagado, code: 'OK' } };

                  // PIT 40803 \\
                  const validOption = ['/instancebrowser', '/workflowSearch'];

                  const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

                  if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
                    //const oriValue = JSON.parse(dadosOrigem);
                    this.destinoRouter = dadosOrigem.origemDoAcesso;
                  }
                  else {
                    this.destinoRouter = 'workflowSearch';
                  }
                  // PIT 40803 \\

                  this.router.navigate([this.destinoRouter], navigationExtras);
                },
                  error => {
                    console.error(error);
                    this.loadingMaskService.setShowLoading(false);
                  }
                )
              }
              else {
                this.alertService.error(wf.message)
              }
              this.loadingMaskService.setShowLoading(false);
            }, error => {
              console.error(error);
              this.loadingMaskService.setShowLoading(false);
              
            });
        }
        else {
          let modal = <models.BaseModalVM>{isError: true, message: "Acção não permitida para o pedido em causa." };
          this.modalS.showModals([modal]).subscribe(result => {
              console.log(result);
              this.loadingMaskService.setShowLoading(false);
              this.router.navigate([`workflowSearch`]);
              return false;
            }
          );

        }
        });
      }, error => {
        console.error(error);
        this.loadingMaskService.setShowLoading(false);
      });
  }

  public documentTypeDescription: string = "";

  public savePreStageInstance(showAlert: boolean = true, func: Function = null, isNextStep: boolean = false) {
    this.loadingMaskService.setShowLoading(showAlert, false);
    this.savePreStageDocumentsOnForm();
    this.preStageFinalServiceSelection();

    return this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/SavePreStageInstance', this.preStageRoot, { params: { workflowInstance: this.workflowInstanceId } }).subscribe(res => {



      this.loadingMaskService.setShowLoading(false);
      if (res.stateCode == 'XE') {
        this.alertService.error(res.message);
        return;
      }
      else if (res.stateCode == 'E') {
        this.alertService.error(res.message);
        return;
      }

      if (!isNextStep) this.router.navigate([`workflow-create/${this.workflowCode}/${this.workflowInstanceId?.toString()}/${this.subscriberNumber}`]);

      if (showAlert) {
        this.alertService.success("Workflow.NextSaveSucess");
      }
      if (func != null) func();
      return;


    },
      error => this.loadingMaskService.setShowLoading(false));


  }

  public prestageMotiveChanged() {
    this.preStageForm.preStageInfo.subscriberMotiveDescServ = this.dropdownListaMotivosEXAP.find(m => m.value == this.subscriberMotive)?.filter;
  }

  public annulationMotiveChanged() {
    this.bAnnulationExtraDesc = this.dropdownListaMotivosAnnulation.find(m => m.value == this.annulationMotive)?.type == "1" ? true : false;
  }

  public loadWorkflowInstance(workflowInstanceId: number) {

    this.http.get<models.StepPrestageRootVM>('api/Workflow/LoadWorflowInstanceData', { params: { workflowInstanceId: workflowInstanceId } as {} }).subscribe(result => {
      this.preStageRoot = result;
      this.preStageForm = this.preStageRoot.stepPreStage;
      this.isAllowPersonalData = this.preStageForm.preStageInfo.allowPersonalData == "S" ? true : false;
      this.respostaExSubscritor = this.preStageForm.preStageInfo.acceptPreselect.toLowerCase() == "true";

      this.documentsList = result.stepPreStage.stepDocuments?.documentationMandatory?.documentsList;
      this.cgaJustification = result.stepPreStage.stepDocuments?.documentationMandatory?.aditionalInformation;
      
      //load de resumo para serviço em caso de pedidos de ex-subscritores + fluxo funcional de SP's a chamar
      if ((this.workflowCode.indexOf('PEDI008') > -1 || this.workflowCode.indexOf('PEDI005') > -1) && this.isService
      ) {
        this.currentStep = result.stepPreStage.preStageInfo.isPrestageFinished == 'true' ? 99 : 98;
        if (this.workflowCode.indexOf('PEDI008') > -1 && this.currentStep == 99) {
          this.router.navigate([`workflow/${this.workflowInstanceId.toString()}/step/StepServiceInfo`]);
          return;
        }
      }
      else {
        this.calculateCurrentPrestageServiceScenario();
        this.populateAndFormatSubscriberServicesList();
        this.loadMotivosDropdown();
        this.currentStep = 1;
        this.preStageStep = 1;
      }
      
      this.evaluateInstancePhase(result.stepPreStage.preStageInfo.isSentCGA == 'true', () => { this.loadingMaskService.setShowLoading(false) });
      
      },
        error => this.loadingMaskService.setShowLoading(false)

      );
  }

  public evaluateInstancePhase(isSentCGA: boolean, func: any) {
    this.http.get<models.InstanceStatusVM>('api/Workflow/GetInstanceStatusPhase', { params: { instanceId: this.workflowInstanceId, subscriberNumber: this.subscriberNumber } }).subscribe(res => {

      this.isReadonly = (res.ppeinst_fase == 'PCS' || res.ppeinst_fase == 'AIC') && res.ppeinst_esta == 'P';
      this.isFromCGA = res.ppeinst_fase == 'PCS' && res.ppeinst_esta == 'P' && isSentCGA;
      if (this.isReadonly && this.preStageForm.preStageInfo.serviceFinal=="0") {
        this.preStageForm.preStageInfo.serviceFinal = "-1";
      }
      if (func) func();
    });
  }

  public subscriberMotive: string = "undefined";
  public annulationMotive: string = "undefined";
  public annulationMotiveOtherDesc: string = "";


  public loadMotivosDropdown() {
    this.loadWorkflowDropdowns().subscribe(result => {
      this.dropdownListaMotivosEXAP = result.options.filter(el => el.dropdown === "dropListMotivosEXAP");
      if (this.preStageForm.preStageInfo.subscriberMotive == "null" || this.preStageForm.preStageInfo.subscriberMotive == "" || this.preStageForm.preStageInfo.subscriberMotive == null) {
        //dar clear ao motivo para a dropdown default
        this.subscriberMotive = "undefined";
        this.preStageForm.preStageInfo.subscriberMotiveDescServ = "";
      } else {
        this.subscriberMotive = this.preStageForm.preStageInfo.subscriberMotive;
      }

    });
    this.documentTypeDescription = this.documentTypes.find(x => x.code == this.preStageForm.exSubscritorIdentificacao.tipoDocumentoID).description;

  }

  public loadAnulacaoMotivosDropdown() {
    this.loadingMaskService.setShowLoading(true);
    this.loadWorkflowDropdowns().subscribe(result => {
      this.dropdownListaMotivosAnnulation = result.options.filter(el => el.dropdown === "dropListMotivosAnul");
      //dar clear ao motivo para a dropdown default
      this.annulationMotive = "undefined";
      this.annulationMotiveOtherDesc = "";
      //this.loadingMaskService.setShowLoading(false);
    
      this.loadingMaskService.setShowLoading(false);

    });
    
  }

  acceptServiceManifest() {

    this.loadingMaskService.setShowLoading(true, false);
    //venha de CGA ou não, é necessário forçar variaveis isSentCGA a false para SP's + isPreStage fica apenas finalizado neste ponto do fluxo
    this.preStageForm.preStageInfo.isPrestageFinished = "true";
    this.preStageForm.preStageInfo.isSentCGA = "false";
    this.preStageRoot.stepPreStage = this.preStageForm;
    //TODO instanceid parameter esta string? deve ser inteiro
    this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/AcceptPreStageManifest', this.preStageRoot, { params: { subscriberNumber: this.subscriberNumber, instanceId: <any>this.workflowInstanceId } })
      .subscribe(result => {
        this.loadingMaskService.setShowLoading(false);
        if (result.stateCode == 'ER') {
          let modal = <models.BaseModalVM>{ isError: true, message: result.message };
          this.modalS.showModals([modal]).subscribe(result => console.log(result));
          return;
        }
        else if (result.stateCode == 'E') {
          let modal = <models.BaseModalVM>{ isError: true, message: result.message };
          this.modalS.showModals([modal]).subscribe(result => console.log(result));
          return;
        }

        if (result.stateCode == 'OK') {
          if (this.workflowCode.indexOf('PEDI008') > -1) {
            this.router.navigate(['workflow', this.preStageRoot.stepPreStage.preStageInfo.instance, 'step', result.stepCode]);
          }
          else if (this.workflowCode.indexOf('PEDI005') > -1) {
            
            this.loadingMaskService.setShowLoading(true, true, false);
            this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/SubmitPreStageInstance', this.preStageRoot, { params: { workflowCode: this.preStageForm.preStageInfo.subscriberMotive, subscriberNumber: <any>this.subscriberNumber, forceNew: 'F' } })
              .subscribe(result => {

                if (result.stateCode == 'ER') {
                  let modal = <models.BaseModalVM>{ isError: true, message: result.message };
                  this.modalS.showModals([modal]).subscribe(result => console.log(result));
                  return;
                }
                this.router.navigate([`workflow/${this.preStageRoot.stepPreStage.preStageInfo.instance}/step/StepServiceInfo`]);
                return;

              },
                error => this.loadingMaskService.setShowLoading(false)

              );
          }
        
        }
        else {
          //TODO
            this.loadingMaskService.setShowLoading(false)
        }
      },
        error => this.loadingMaskService.setShowLoading(false)

      );
  }

  rejectionServiceManifestBackButton() {
    if (this.serviceManifestRejectSucessfully)
      this.router.navigate(['workflowSearch']);
    else
      this.currentStep = 98;

  }

  rejectServiceManifest() {

    this.loadingMaskService.setShowLoading(true);
    this.preStageRoot.stepPreStage.preStageInfo.nOKReason = this.motivoRejeicaoManifestoEx;
    //TODO instanceid parameter esta string? deve ser inteiro
    this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/RejectPreStageManifest', this.preStageRoot, { params: { subscriberNumber: this.subscriberNumber, instanceId: <any>this.workflowInstanceId } })
      .subscribe(result => {

        if (result.stateCode == 'ER') {
          let modal = <models.BaseModalVM>{ isError: true, message: result.message };
          this.modalS.showModals([modal]).subscribe(result => console.log(result));
        }
        else if (result.stateCode == 'E') {
          let modal = <models.BaseModalVM>{ isError: true, message: result.message };
          this.modalS.showModals([modal]).subscribe(result => console.log(result));
          return;
        }

        this.serviceManifestRejectSucessfully = true;
        this.loadingMaskService.setShowLoading(false);
        this.router.navigate(['/workflow-create', this.workflowCode, result.workflowInstanceId, "null", 'submited-manifest']);

      },
        error => this.loadingMaskService.setShowLoading(false)

      );
  }

  populateAndFormatSubscriberServicesList() {
    this.subscriberServices = this.preStageForm.exSubscritorVinculosVM.vinculosList;
    var servicosIntegracaoServicoSugerido = this.preStageForm.exSubscritorServicoSugerido?.servIntegracoesList;
    this.subscriberServices = _.cloneDeep(this.subscriberServices.filter(ss => ss.chaveServico != this.preStageForm.exSubscritorServicoSugerido.chaveServico));

    this.subscriberServices = [...this.flattenListaVinculos(servicosIntegracaoServicoSugerido), ...this.flattenListaVinculos(this.subscriberServices as models.VinculoServicoVM[])];

    if (this.subscriberServices.length == 0 || this.subscriberServices == null) return;

    //this.subscriberServices = this.subscriberServices.filter(serv => !(serv.estado == 'D' && serv.servIntegracoesList?.length > 0))
    //tirar duplicados
    this.subscriberServices = this.subscriberServices.reduce((arr: models.VinculoServicoVM[], obj: models.VinculoServicoVM) => {
      let existing = arr.find(item => item.chaveServico == obj.chaveServico && item.servInicialChave == obj.servInicialChave);
      if (!existing) arr.push(obj);
      return arr;
    }, [])


    if (this.subscriberServices.every(serv => serv.estado == 'D' || (serv.estado == 'A' &&
      (
      (serv.registadoCGADIR == '0' && serv.numSubsAtivos == '0')
      || (serv.registadoCGADIR == '0')
      || (serv.numSubsAtivos == '0')
      )
    ) 
    )) this.subscriberServices = [];

    //adicionar opçao 'nenhumas das anteriores'
    if (this.subscriberServices.length > 0) this.subscriberServices.push(this.noOptionService);

    const servicoFinalTemp = parseInt(this.preStageForm.preStageInfo.serviceFinal );
    if (this.currentServiceScenario !== this.Scenarios.Ativo
      && this.currentServiceScenario !== this.Scenarios.AtivoIntegradoExtinto
      && this.currentServiceScenario !== this.Scenarios.AtivoIntegradoAtivo
      && this.subscriberServices.length == 0) {
      if (servicoFinalTemp <= 0) {
        this.preStageForm.preStageInfo.serviceFinal == "-1";
      }
    }


    //selecionamos o servico escolhido se existir
    if (this.preStageForm.preStageInfo.serviceFinal != '0' || this.preStageForm.preStageInfo.serviceFinal != null) {
      if (servicoFinalTemp <= 0) {
        if (this.preStageForm.preStageInfo.serviceFinal == '000' || this.preStageForm.preStageInfo.serviceFinal == "-1") {
          this.finalService = this.noOptionService as models.VinculoServicoVM;
          return;
        }
        //this.finalService = this.subscriberServices.find(sev => sev.chaveServico == this.preStageForm.preStageInfo.serviceFinal && sev.servInicialChave == this.preStageForm.preStageInfo.serviceFinalIntegracao) as models.VinculoServicoVM;
      }

      this.finalService = this.subscriberServices.find(sev => sev.chaveServico == this.preStageForm.preStageInfo.serviceFinal && sev.servInicialChave == this.preStageForm.preStageInfo.serviceFinalIntegracao) as models.VinculoServicoVM;
    }

  }

  ngOnDestroy() {
    // The next line is telling header component to hide the help button;
    this.stepDetailsService.workFlowCode.next(null);
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }
  //INTERNAL API CALLS
  /**
  * Loads generic information for give WorkFlow
  *
  * @remarks
  * This is an api call
  *
  */
  public loadWorkflowDetails() {
    const workflowInformation$: Observable<models.WorkflowInformationVM> =
      this.http.get<models.WorkflowInformationVM>('api/Workflow/LoadWorflowInformation', {
        params: {
          workflowInstanceId: this.workflowInstanceId,
          workflowCode: this.workflowCode          
        }
      }
      );

    const workflowsHelpLinks$: Observable<models.WorkflowHelpLinkVM[]> =
      this.http.get<models.WorkflowHelpLinkVM[]>('api/WorkflowSearch/LoadWorkflowsHelpLinks', {});

    combineLatest(workflowInformation$, workflowsHelpLinks$)
      .pipe(
        filter(([workflowsInformations, workflowsHelpLinks]) => workflowsInformations !== null && workflowsHelpLinks !== null),
        map(([workflowsInformation, workflowsHelpLinks]) => {
          if (!this.isNumeric(workflowsInformation.workFlowHelpLink) && workflowsInformation.workFlowHelpLink.length > 0) {
            const foundEntry = workflowsHelpLinks.find(wh => wh.codigo == workflowsInformation.workFlowHelpLink);
            if (foundEntry !== null && foundEntry !== undefined) {
              workflowsInformation.workFlowHelpLink = foundEntry.refFichId.toString();
            } else {
              const logModel: models.LogModelVM = {
                message: `Could not found refFichId for workFlowHelpLink: ${workflowsInformation.workFlowHelpLink}`,
                type: LogType.Error
              };
              this.logService.logToBackend(logModel);
              this.cacheService.cacheMissingHelpLink(workflowsInformation.workflowCode);
            }
            
          }

          return workflowsInformation;
        }),
    )
    .subscribe((result) => {
      this.workflowDefinition = result;
    }, error => console.error(error));
  }

  private isNumeric(str: string): boolean {
    if (typeof str != "string") return false; // we only process strings!
    if (str === null || str === undefined) return false; // null or undefineds are not numbers
    if (str.length === 0) return false; // empty string are not numbers
    return !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }
  /**
  * Search for a given subscriber
  *
  * @remarks
  * This is an api call
  *
  */
  public getWorkflowInstance() {
    //console.log(`Check Subscriber and workflow instance exists: ${this.workflowCode}, ${this.subscriberNumber}`)
    let state;
    this.loadingMaskService.setShowLoading(true, false, this.workflowCode.indexOf("PEDI0020") > -1);
    const isCT = this.workflowCode.indexOf("PEDI0020") > -1;
    this.http.get<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/CreateWorkFlowInstance', { params: { workflowCode: this.workflowCode, subscriberNumber: <any>this.subscriberNumber, forceNew: <any>this.forceNew } }
    ).subscribe(result => {
      // SET STATE IN CT FOR PEDI0020A e PEDI0020B
      if (isCT) {
        const tempFake = [...this.fakeChildWorkFlows];
        const existeA = result.childWorkFlows.find(el => el.workflowCode == "PEDI0020A");
        if (existeA != null) {
          tempFake.find(el => el.workflowCode == "PEDI0020A").isLogActive = "S";
        }
        const existeB = result.childWorkFlows.find(el => el.workflowCode == "PEDI0020B");
        if (existeB != null) {
          tempFake.find(el => el.workflowCode == "PEDI0020B").isLogActive = "S";
        }
        this.fakeChildWorkFlows = [...tempFake];
      }

      //SET RESULT VARIABLES
      this.workflowInstanceId = result.workflowInstanceId;
      this.stepCode = result.stepCode;
      this.exists = result.exists;
      this.revisionNeeded = result.revisionNeeded;
      this.estaRegi = result.estaRegi;
      this.pediObri = result.pediObri;
      this.childWorkFlows = result.childWorkFlows;
      this.childWorkFlowsVoluntaria = result.childWorkFlows.filter(el => el.isWorkflowMandatory == 'N');
      this.childWorkFlowsObrigatoria = result.childWorkFlows.filter(el => el.isWorkflowMandatory == 'S');
      const permitDelete = result.allowDelete;
      state = result.stateCode;
      //IF HAS MESSAGES
      if (this.workflowCode === "PEDI0020") {
        this.tipoPedidoDescricao = " um pedido de Contagem de Tempo ";
      }


      if ((this.pediObri && this.estaRegi && this.exists) || (isCT && this.estaRegi )) {
        this.http.get<models.WorkflowInstanceVM>('api/InstanceBrowser/InitInstanceAtendimento',
          { params: { workflowInstanceId: result.workflowInstanceId.toString() } }
        ).subscribe(data => {
          var canInitAtend = (data.stateCode.trim().toLowerCase() == 'ok');

          if (canInitAtend) {
            this.router.navigate([`workflow/${result.workflowInstanceId.toString()}/step/${this.isService ? 'StepServiceInfo' : 'StepSubscriberInfo'}`]);
            return;
          } else {
            this.alertService.error(data.message);
          }
          this.loadingMaskService.setShowLoading(false);
        }, error => this.loadingMaskService.setShowLoading(false),
        );
        return;
      }
      else if (!this.pediObri && this.estaRegi) {
        this.http.get<models.InstanceBrowserVM>('api/InstanceBrowser/CanOpenRegistredInstance',
          { params: { instanceID: result.workflowInstanceId.toString(), subscriberNumber: this.subscriberNumber.toString(), ownerType: this.tipoUtilizador } }
        ).subscribe(data => {

          var canOpen = (data.stateCode.trim().toLowerCase() == 'true');

          if (canOpen) {
            this.router.navigate([`workflow-create/${data.message}/${result.workflowInstanceId}/${this.subscriberNumber}`]);
          } else {
            this.alertService.error(data.message);
          }
          this.loadingMaskService.setShowLoading(false);
        }, error => this.loadingMaskService.setShowLoading(false),
        );
        return;
      }


      if (state && state != 'OK') {
        //console.log(result);
        let data: any;
        data = { 'subscriberNumber': this.subscriberNumber };

        let modal = <models.BaseModalVM>{
          isError: result.stateCode == 'ER' && result.message != "WorkflowCreate.CannotFindSubscriber",
          message: result.message, param: data,
          cancelButton: {
            hideButton: result.message == "WorkflowCreate.CannotFindSubscriber",
            buttonText: result.stateCode == 'ER' ? "Ok" : null,
            buttonClass: result.stateCode == 'ER' ? 'btn-primary' : ' btn-outline-primary',
            iconClass: result.stateCode == 'ER' ? "icon-check" : null
          }
        };
        this.modalS.showModals([modal]).subscribe(result => {
          //console.log(result)
          if (state != 'ER') {

            if (this.exists && result ===true) {  //THERE IS ALREADY A WORKFLOW INSTANCE SHOW DIALOG
              this.allowDelete = permitDelete;
              this.modalRef = this.modalService.show(
                this.withData,
                Object.assign({}, { class: 'modal-lg' }));
            }
            else if(result) {
              //IF DOSENT HAVE INSTANCE JUMPS DIRECTLY TO JUSTIFICATION LIST
              if (this.childWorkFlows)
                this.currentStep = 1;
            };
          }
        });
      }
      else {
        if (this.revisionNeeded) {
          this.modalRef = this.modalService.show(
            this.revisionNeededModal,
            Object.assign({}, { class: 'modal-lg' }));
        }
        else if (this.exists) {  //THERE IS ALREADY A WORKFLOW INSTANCE SHOW DIALOG
          this.allowDelete = permitDelete;
          this.modalRef = this.modalService.show(
            this.withData,
            Object.assign({}, { class: 'modal-lg' }));
        }
        else {
          //IF DOSENT HAVE INSTANCE JUMPS DIRECTLY TO JUSTIFICATION LIST
          if (this.childWorkFlows)
            this.currentStep = 1;
        };
      }
      this.loadingMaskService.setShowLoading(false);

    }, error => {
      this.loadingMaskService.setShowLoading(false);
      this.alertService.error('Generic.GlobalError');
      console.error(error);
    }
    );
  }

  /**
 * Search for a given subscriber
 * 
 * @remarks
 * This is an api call
 *
 */
  public createWorkflowInstance() {
    let wf = this.childWorkflow ? this.childWorkflow : this.workflowCode;
    const isCT = this.workflowCode.indexOf("PEDI0020") > -1;
    this.loadingMaskService.setShowLoading(true, true, isCT);
    this.http.get<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/CreateWorkFlowInstance', { params: { workflowCode: wf, subscriberNumber: <any>this.subscriberNumber, forceNew: <any>this.forceNew } }
    ).subscribe(result => {
      this.workflowInstanceId = result?.workflowInstanceId;
      this.loadingMaskService.setShowLoading(false);

      if (result.stateCode == 'ER') {
        let modal = <models.BaseModalVM>{ isError: true, message: result.message };
        this.modalS.showModals([modal]).subscribe(result => console.log(result));
      }
      else {
        if (result.stateCode == 'INFO') {

          let modal = <models.BaseModalVM>{ isError: false, message: result.message };
          this.modalS.showModals([modal]).subscribe(result => console.log(result));
        }
        if (result.stateCode == 'NOREG') {
          this.modalRef = this.modalService.show(
            this.noRegistration,
            Object.assign({}, { class: 'modal-lg' })
          );
        }
        this.childWorkFlows = result.childWorkFlows;

        if (this.childWorkFlows)
          this.currentStep = 1;

        //IF service returns StateCode MAN then ask for manifest
        if (result.stateCode == 'MAN') {
          this.currentStep = 2;
        }
        else if (result.stepCode) {
          this.router.navigate(['workflow', result.workflowInstanceId, 'step', result.stepCode]);
        }
      }
    }, error => {
      window.scrollTo(0, 0);
      this.loadingMaskService.setShowLoading(false);
      this.alertService.error('Generic.GlobalError');
      console.error(error);
    }
    );
  }

  /**
* Create manifest
*
* @remarks
* This is an api call
*
*/
  public createManifest(event: Event, btn: HTMLButtonElement) {    

    btn.disabled = true;

    //var btn = (event.target) as HTMLInputElement;
    //btn.disabled = true;

    //return;

    //console.log(`Create Manifest for subscriber and associate to WF: ${this.workflowCode}, ${this.subscriberNumber}`)
    this.loadingMaskService.setShowLoading(true);
    this.alertService.clear();

    this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/CreateManifest', null, { params: { workflowCode: this.workflowCode, subscriberNumber: <any>this.subscriberNumber, workflowInstanceId: this.workflowInstanceId } }
    ).subscribe(res => {
      if (res.stateCode == 'E') {
        let modal = <models.BaseModalVM>{ isError: true, message: res.message };
        this.modalS.showModals([modal]).subscribe(result => console.log(result));
        return;
      }
      this.loadingMaskService.setShowLoading(false);
      //redirecionar para a home e mostrar mensagem.
      const navigationExtras: NavigationExtras = { state: { data: 'WorkflowCreate.ManifestEmailSent', code: 'OK' } };
      btn.disabled = false;
      this.router.navigate(['submited'], navigationExtras);
    }, error => {
      this.loadingMaskService.setShowLoading(false);
      //this.alertService.error('Generic.GlobalError');  
        console.error(error);

        // Reenable the button
        btn.disabled = false;
    }
    );
  }

  //COMPONENT RELATED METHODS
  /** 
  * Got to previous step in WF creation
  *
  * @remarks
  * This is the workflow module interface.
  *
  */
  onStepBefore() {

    // PIT 40802 \\
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } else {
        // check PRE STAGE
        if (this.isOnPreStage() ) {
          this.onStepBeforePreStage();
          return;
        }
        if (this.currentStep >= 0 && this.currentStep < this.steps.length - 1)
          this.currentStep = this.currentStep - 1;
        if (this.currentStep == 0)
              this.childWorkflow = undefined;
      }

    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }




  /**
  * Got to next step, validate data and navigate
  *
  * @remarks
  * This is the workflow module interface.
  *
  */
  onStepNext() {
    this.alertService.clear();

    // PIT 40802 \\
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } else {
        // check PRE STAGE
        if (this.isOnPreStage()) {
          this.onStepNextPreStage();
          return;
        }

        //if (this.currentStep == 0 && (!!this.subscriberNumber || !!this.exSubscriberNumber)) {
        if (this.currentStep == 0 && !!this.subscriberNumber) {
          if (this.workflowCode == 'PEDI008B') {
            this.createSubmitPrestageCTO();
          }
          else {
            this.getWorkflowInstance();
          }
          // Validar se ex
          /*if (!!this.subscriberNumber) {
            this.getWorkflowInstance();
          } else {
            if (!!this.exSubscriberNumber) {
              this.getWorkflowInstance();
              this.loadingMaskService.setShowLoading(true);
              this.checkIfItsAnExSubscriptor()
                .subscribe((result: models.WorkflowStatusVM) => {
                  this.loadingMaskService.setShowLoading(false);
                  if (result.stateCode == "OK") {
    
                  }
                  else {
                    if (!result.exists) {
                    } else {
                      let modal = <models.BaseModalVM>{
                        isError: true,
                        message: result.message, param: {},
                        cancelButton: {
                          hideButton: true,
                          buttonText: "Ok",
                          buttonClass: 'btn-primary',
                          iconClass: "icon-check"
                        }
                      };
    
                      this.modalS.showModals([modal]);
    
                    }
                    return;
                  }
                });
              
            }
            
          }*/

        }
        else if (this.currentStep == 1 && this.childWorkflow) {
          if (!isNullOrUndefined(this.childWorkflow) && this.childWorkflow == "PEDI001E")
            this.showAgeLimitModal();
          else {
            this.createWorkflowInstance();

          }
        }

      }

    },
      error => this.loadingMaskService.setShowLoading(false)
    );

    
  }

  createSubmitPrestageCTO() : any
  {
    this.loadingMaskService.setShowLoading(true);

    this.http.get('api/WorkflowInstanceCreator/ValidaExSubscritor', { params: { workflowCode: this.workflowCode, subscriberNumber: <any>this.subscriberNumber} }
    ).subscribe((res: any) => {
      if (res == 1) { //Ex Subscritor válido
        //this.loadingMaskService.setShowLoading(false);
        //redirecionar para a home e mostrar mensagem.
        this.http.get<models.StepPrestageRootVM>('api/WorkflowInstanceCreator/CreatePreStageInstance', { params: { workflowCode: this.workflowCode, subscriberNumber: <any>this.subscriberNumber } })
          .subscribe(result => {
            if (result.version != -99) {
              result.stepPreStage.preStageInfo.allowPersonalData = "N";
              result.stepPreStage.preStageInfo.serviceFinal = this.securityService.userDetails.service;
              result.stepPreStage.preStageInfo.isSentCGA = "false";

              this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/SubmitPreStageInstance', result, { params: { workflowCode: this.workflowCode, subscriberNumber: <any>this.subscriberNumber } })
                .subscribe(resultS => {
                  //this.loadingMaskService.setShowLoading(false);
                  if (resultS.stateCode == 'ER') {
                    let modal = <models.BaseModalVM>{ isError: true, message: resultS.message };
                    this.modalS.showModals([modal]).subscribe(result => console.log(result));
                    return;
                  }
                  if (resultS.stateCode == 'OK') {
                    if (this.isService) {
                      this.router.navigate(['workflow', result.stepPreStage.preStageInfo.instance, 'step', resultS.stepCode]);
                    } else {
                      this.router.navigate(['/workflow-create', this.workflowCode, resultS.workflowInstanceId, result.stepPreStage.preStageInfo?.serviceFinal, 'submited-manifest']);
                    }
                    return;
                  }
                },
                  error => this.loadingMaskService.setShowLoading(false)
                );

            } else {

              let modal = <models.BaseModalVM>{
                isError: true, //result.stateCode == 'ER' ? true : false,
                message: result.stepPreStage.preStageInfo.serviceFinal,
                param: null,
                cancelButton: {
                  hideButton: true,
                  buttonText: "Ok",
                  buttonClass: 'btn-primary',
                  iconClass: "icon-check"
                }
              };
              this.modalS.showModals([modal]);
            }
            //this.loadingMaskService.setShowLoading(false);
          },
            error => {
              if (error == "subscriberNumberError") {
                let data: any;
                data = { 'subscriberNumber': this.subscriberNumber };

                let modal = <models.BaseModalVM>{
                  isError: true, //result.stateCode == 'ER' ? true : false,
                  message: "O número de subscritor é inválido!",
                  param: data,
                  cancelButton: {
                    hideButton: true,
                    buttonText: "Ok",
                    buttonClass: 'btn-primary',
                    iconClass: "icon-check"
                  }
                };
                this.modalS.showModals([modal]);

              }
              this.loadingMaskService.setShowLoading(false);
            }
          );

        return true;
      }
      else { //Ex Subscritor inválido
        this.loadingMaskService.setShowLoading(false);
        this.alertService.warn('Generic.GlobalError');
        return false;
      }
      
    }, error => {
      this.loadingMaskService.setShowLoading(false);
      this.alertService.error('Generic.GlobalError');  
      return false;
    }
    );
  }

  //private checkIfItsAnExSubscriptor(): Observable<models.WorkflowStatusVM> {
    
  //  return this.http.get<models.WorkflowStatusVM>('api/SubscriberInfo/IsExSubscriberNumber',
  //    {
  //      params: {
  //        exSubscriberNumber: this.exSubscriberNumber,
  //        workflowCode: 'PEDI008' //this.workflowCode
  //      }
  //    });
    
  //}

  verifySubscriber() {
    //this.http.get<models.WorkflowStatusVM>(
    //  'api/WorkflowInstanceCreator/CanCreatePreStage',
    //  {
    //    params: {
    //      workflowCode: this.workflowCode,
    //      subscriberNumber: this.subscriberNumber
    //    }
    //  }
    //).subscribe(result => {
      
    if (this.workflowCode === "PEDI008") {
      this.CreatePreStageInstance();
    } else {
      this.getWorkflowInstance();
    }
    //});

  }


  /**
  * Cancel send manfest of interest
  *
  * @remarks
  * This is the workflow module interface.
  *
  */
  onCancel() {
  //  this.currentStep = 0;
	
//	this.router.navigate(['instancebrowser']);
//	return;
    this.alertService.clear();

    this.http.get<models.WorkflowStatusVM>(
      'api/WorkflowInstanceCreator/RejectManifest',
      {
        params: {
          instanceId: this.workflowInstanceId.toString(),
          manifest: "-1"  // No manifest code, because there is no manifest
        }
      }
    ).subscribe(result => {
      if (result.stateCode == "OK") {
        // The next line is telling header component to hide the help button;
        this.stepDetailsService.workFlowCode.next(null);

        // PIT 40803 \\
        const validOption = ['/instancebrowser', '/workflowSearch'];

        const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

        if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
          this.destinoRouter = dadosOrigem.origemDoAcesso;
        }
        else {
          this.destinoRouter = '/workflowSearch';
        }

        this.router.navigate([this.destinoRouter]);
        // PIT 40803 \\

      } else {
        this.alertService.error(result.message);      }
    });
  }

  onExit() {
    this.alertService.clear();
    this.router.navigate([`workflow/${this.workflowInstanceId.toString()}/step/StepServiceInfo`]);
    //this.router.navigate(['instancebrowser']);
  }
  /**
  * Get justification code from radio button list
  *
  * @remarks
  * This is the workflow module interface.
  *
  */
  onSelectionChange(entry) {
    this.childWorkflow = entry.workflowCode;
  }


  confirmNoReg(): void {
    window.open(this.cgaDirectaAddress);
  }

  confirmNew(): void {

    if (this.optDraft == "withDraftOp1") {
      if (this.workflowInstanceId && this.stepCode) { //USE DRAFT AND MANDATORY
        this.router.navigate(['workflow', this.workflowInstanceId, 'step', this.stepCode]);
      }
      else {
        this.forceNew = false;
        this.createWorkflowInstance();
      }
    }
    else if (this.optDraft == "withDraftOp2") {
      this.forceNew = true;
      this.createWorkflowInstance();
    }
    this.allowDelete = true;
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  showAgeLimitModal() {
    let modal = <models.BaseModalVM>{
      isError: false,
      message: 'WorkflowCreate.AgeLimitAlertMessage'
    };
    this.modalS.showModals([modal]).subscribe(result => {
      if (result)
        this.createWorkflowInstance();
    });
  }

  public getInstructions() {
    if (!this.cacheService.isMissingHelpLink(this.workflowDefinition.workflowCode)) {
      this.cgaGetFileFormInput.nativeElement.value = this.workflowDefinition.workFlowHelpLink;
      this.cgaGetFileForm.nativeElement.action = this.domain;
      this.cgaGetFileForm.nativeElement.submit();
    } else {
      const message = this.translate.instant("BaseModal.HelpLinkNotFound");
      this.alertService.error(message);
    }

  }

  public confirmRevision() {
    this.modalRef.hide();
    this.router.navigate(['workflow', this.workflowInstanceId, 'step', this.stepCode]);
  }


  // #region EXSUBSCRITORES 

  onStepBeforePreStage() {
    if (this.preStageStep > 1) {
      if (this.cgaSubmitedDocuments) {
        this.cgaSubmitedDocuments = false;
      }
      else {
        this.preStageStep--;
      }

    }

  }

  verifyIsSentCga() {
    const serviceFinal = parseInt(this.preStageForm.preStageInfo.serviceFinal);
    if (Number.isNaN(serviceFinal) || serviceFinal <= 0) {
      this.preStageForm.preStageInfo.isSentCGA = String(
        (this.subscriberServices.length == 0 && (this.respostaExSubscritor == false || this.respostaExSubscritor == null || this.respostaExSubscritor == undefined))
        ||
        (this.subscriberServices.length >= 0 && this.preStageForm.preStageInfo.serviceFinal == "-1" && (this.respostaExSubscritor == false || this.respostaExSubscritor == undefined || this.respostaExSubscritor == null))
        ||
        (this.currentServiceScenario == this.Scenarios.NaoInscritoOuSemSubsAtivos && (this.subscriberServices.length == 0 || (this.subscriberServices.length >= 0 && this.preStageForm.preStageInfo.serviceFinal == "-1")))
        ||
        this.preStageForm.preStageInfo.isSentCGA == "true"
      );

    } else {
      this.preStageForm.preStageInfo.isSentCGA = "false";
    }
  }

  onStepNextPreStage() {

    if (this.preStageStep == 1) {
      if (
        //(this.preStageRoot.stepPreStage.preStageInfo.subscriberMotive == "undefined" || this.preStageRoot.stepPreStage.preStageInfo.subscriberMotive === undefined || this.preStageRoot.stepPreStage.preStageInfo.subscriberMotive === null) ||
        ((this.subscriberMotive == "undefined" || this.subscriberMotive === undefined || this.subscriberMotive === null || this.subscriberMotive == "null") && this.subscriberMotive.indexOf('PEDI005') != -1) ||
        (this.preStageRoot.stepPreStage.preStageInfo.allowPersonalData != "S" && this.preStageRoot.stepPreStage.preStageInfo.allowPersonalData != "N") ||
        (this.preStageRoot.stepPreStage.preStageInfo.serviceFinal === null || this.preStageRoot.stepPreStage.preStageInfo.serviceFinal === undefined || this.preStageRoot.stepPreStage.preStageInfo.serviceFinal == "")
      ) {
        let modal = <models.BaseModalVM>{ isError: true, message: "Não é possível avançar com o pedido, existe informação em falta. Por favor reveja a informação inserida." };
        this.modalS.showModals([modal]).subscribe(result => console.log(result));
        return false;
      }
    }
    
    if (this.preStageStep != 2) {
      var baseModal = <models.BaseModalVM>{ isError: false, message: "Generic.ConfirmNotAllowingPersonalData" };
      if (this.preStageForm.preStageInfo.allowPersonalData == 'N' && !this.isAtendimento && !this.isReadonly) {
        this.modalS.showModals([baseModal]).subscribe(result => {
          if (result) {
            if (this.preStageStep == 1) {
              this.verifyIsSentCga();
            }
            this.preStageStep = this.preStageStep + 1;
          }
        });
      }
      else {
        //colocar o seguinte código em metodo distinto?
        if (this.preStageStep == 1) {
          this.verifyIsSentCga();
        }
        this.preStageStep = this.preStageStep + 1;
      }
      if (this.atendimento !== "A") { this.savePreStageInstance(false, null, true); }
    } else {
      if (this.preStageForm.preStageInfo.isSentCGA == "true" ) {
        if (this.cgaSubmitedDocuments == true) {
          if (this.verifyPreStageDocuments()) {
            //alert('this.getREFTarefaPS().SyncDocuments.submitPreStageInstance();');

            this.getREFTarefaPS().subscribe(ifedorchav => {
              this.http.post('api/Documents/SyncDocuments', ifedorchav, { params: { workflowInstanceId: this.workflowInstanceId, subscriberNumber: this.subscriberNumber, isPrestage: true } }).subscribe(_ => {
                this.submitPreStageInstance();
              },
                error => this.loadingMaskService.setShowLoading(false)
              );
            });
          } else {
            var baseModal = <models.BaseModalVM>{ isError: true, message: "Generic.ErrorOnSentToCGADocuments" };
            this.modalS.showModals([baseModal]).subscribe(result => {});

          }
        }
        else {
          if (this.verifyPreStageDocuments()) {
            this.savePreStageInstance(false, () => this.cgaSubmitedDocuments = true, true);
          } else {
            var baseModal = <models.BaseModalVM>{ isError: true, message: "Generic.ErrorOnSentToCGADocuments" };
            this.modalS.showModals([baseModal]).subscribe(result => { });

          }
        }
      }
      else {
        //alert('this.submitPreStageInstance();');

        this.submitPreStageInstance();
      }

    }
  }
  verifyPreStageDocumentsList(docList: models.DocumentVM[]): boolean {
    if (docList) {
      let result = true;
      let atLeast = 0;
      docList.forEach(ff => {
        if (ff.fileID == "0" || ff.fileID == null || ff.fileID == null) {
          result = false;
        } else {
          if (ff.designationTypeCode == "MDP170") {
            atLeast += 1;
          }
        }
      });

      return result && atLeast > 0;
    } else {
      return false;
    }
  }

  verifyPreStageDocuments(): boolean {
    if (this.preStageForm.stepDocuments?.documentationMandatory?.documentsList) {
      let result = true;
      let atLeast = 0;
      this.preStageForm.stepDocuments.documentationMandatory.documentsList.forEach(ff => {
        if (ff.fileID == "0" || ff.fileID == null || ff.fileID == null) {
          result = false;
        } else {
          if (ff.designationTypeCode == "MDP170") {
            atLeast += 1;
          }
        }
      });

      return result && atLeast > 0;
    } else {
      return false;
    }
  }
  getREFTarefaPS() {
    return this.http.get<string>('api/WorkflowInstanceCreator/GetREFTarefaPS', { params: { workflowInstance: this.workflowInstanceId, isSentCGA: this.preStageForm.preStageInfo.isSentCGA } });
  }

  savePreStageDocumentsOnForm() {
    var stepDocuments: models.StepDocumentsVM = {
      documentationMandatory: {
        isMandatoryDocumentation: true,
        documentsList: this.documentsList,
        aditionalInformation: this.cgaJustification
      }
    }
    this.preStageForm.stepDocuments = stepDocuments;
  }

  preStageFinalServiceSelection() {
    this.preStageRoot.stepPreStage = this.preStageForm;
    this.preStageForm.preStageInfo.subscriberMotive = this.subscriberMotive;
    //TODO rever
    if (this.childWorkflow == "PEDI008A") {
      this.preStageRoot.stepPreStage.preStageInfo.isSentCGA = "false";
    }

    if (this.childWorkflow == "PEDI008B") {
      this.preStageRoot.stepPreStage.preStageInfo.isSentCGA = "true";
    }
  }

  submitPreStageInstance() {

    if (((this.preStageRoot.stepPreStage.preStageInfo.subscriberMotive == "undefined" || this.preStageRoot.stepPreStage.preStageInfo.subscriberMotive === undefined || this.preStageRoot.stepPreStage.preStageInfo.subscriberMotive === null) && this.preStageRoot.stepPreStage.preStageInfo.subscriberMotive.indexOf('PEDI005') != -1 ) ||
      (this.preStageRoot.stepPreStage.preStageInfo.allowPersonalData != "S" && this.preStageRoot.stepPreStage.preStageInfo.allowPersonalData != "N") ||
      (this.preStageRoot.stepPreStage.preStageInfo.serviceFinal === null || this.preStageRoot.stepPreStage.preStageInfo.serviceFinal === undefined || this.preStageRoot.stepPreStage.preStageInfo.serviceFinal == "")
    )
    {
      let modal = <models.BaseModalVM>{ isError: true, message: "Não é possível avançar com o pedido, existe informação em falta. Por favor reveja a informação inserida." };
      this.modalS.showModals([modal]).subscribe(result => console.log(result));
      return;
    }
    this.preStageFinalServiceSelection();

    this.loadingMaskService.setShowLoading(true, false, false);
    this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreator/SubmitPreStageInstance', this.preStageRoot, { params: { workflowCode: this.workflowCode, subscriberNumber: <any>this.subscriberNumber, workflowInstance: this.workflowInstanceId } })
      .subscribe(result => {
          this.loadingMaskService.setShowLoading(false);
          if (result.stateCode == 'ER') {
            let modal = <models.BaseModalVM>{ isError: true, message: result.message };
            this.modalS.showModals([modal]).subscribe(result => console.log(result));
            return;
          }
          else if (result.stateCode == 'E') {
            let modal = <models.BaseModalVM>{ isError: true, message: result.message };
            this.modalS.showModals([modal]).subscribe(result => console.log(result));
            return;
          }

          if (result.stateCode == 'OK') {
            if (this.isService) {
              this.router.navigate(['workflow', this.preStageRoot.stepPreStage.preStageInfo.instance, 'step', result.stepCode]);
            } else {

              this.router.navigate(['/workflow-create', this.workflowCode, result.workflowInstanceId, this.preStageForm.preStageInfo?.serviceFinal, 'submited-manifest']);


            }
            return;
          }
        },
        error => this.loadingMaskService.setShowLoading(false)

      );
  }

  CheckIfPreStageSeguinteIsDisabled() {
    if (this.currentStep == 0 && this.workflowCode == 'PEDI008B') {
      return false;
    }

    return (this.currentStep == 0 && !this.subscriberNumber)
      //ex subscritor condicoes
      || (!this.isReadonly && this.isExSubscritor && this.currentStep == 99 && (this.childWorkflow == null || this.childWorkflow == undefined))
      || (!this.isReadonly && this.isExSubscritor && this.preStageForm.preStageInfo?.isSentCGA == 'true' && this.preStageStep == 2 && (this.documentsList === null || this.documentsList === undefined || this.documentsList.length === 0 || this.documentsList.some(d => d.fileID == null || d.fileID == undefined)))
      || (!this.isReadonly && this.isExSubscritor && this.currentStep == 1 && this.preStageStep == 1 && this.subscriberServices?.length > 0 && (this.preStageForm.preStageInfo?.serviceFinal == '0' || this.preStageForm.preStageInfo?.serviceFinal == null || this.preStageForm.preStageInfo?.serviceFinal == undefined) && (this.respostaExSubscritor == false || this.respostaExSubscritor == null))
      || (!this.isReadonly && this.isExSubscritor && this.currentStep == 1 && this.preStageStep == 1 && (this.respostaExSubscritor == undefined || this.respostaExSubscritor == null) && this.subscriberServices?.length == 0 && (this.currentServiceScenario == this.Scenarios.Ativo || this.currentServiceScenario == this.Scenarios.AtivoIntegradoAtivo || this.currentServiceScenario == this.Scenarios.AtivoIntegradoExtinto))
      || (this.isReadonly && this.isExSubscritor && this.currentStep == 1 && this.preStageForm.preStageInfo?.isSentCGA == 'false')
      || (this.isReadonly && this.isExSubscritor && this.currentStep == 1 && this.preStageForm.preStageInfo?.isSentCGA == 'true' && this.preStageStep == 2)
      || (!this.isReadonly && this.isAtendimento && this.currentStep == 1 && this.preStageStep == 2 && ((this.preStageForm.preStageInfo?.isSentCGA == 'true' && this.cgaSubmitedDocuments ) || (this.preStageForm.preStageInfo?.isSentCGA == 'false')))
      || (!this.isReadonly && this.currentStep == 1 && this.preStageStep == 1 && this.isExSubscritor && this.workflowCode.indexOf("PEDI005") > -1 && (this.subscriberMotive === "null" || this.subscriberMotive === null || this.subscriberMotive === "" || this.subscriberMotive === "undefined" || this.subscriberMotive === undefined))
      || (!this.isReadonly && this.currentStep == 1 && this.preStageStep == 1 && this.isExSubscritor && (this.preStageForm.preStageInfo?.allowPersonalData === "null" || this.preStageForm.preStageInfo?.allowPersonalData === null || this.preStageForm.preStageInfo?.allowPersonalData === "" || this.preStageForm.preStageInfo?.allowPersonalData === "undefined" || this.preStageForm.preStageInfo?.allowPersonalData === undefined))
      //subscritores normais seguinte em currentStep1
      || (this.currentStep == 1 && !this.isExSubscritor && this.childWorkflow == null)
  }

  isOnPreStage(): boolean {
    let result = (this.workflowCode.indexOf("PEDI008") > -1 || this.workflowCode.indexOf("PEDI005") > -1) && this.currentStep == 1;
    return result;
  }

  CreatePreStageInstance() {

    this.http.get<models.StepPrestageRootVM>('api/WorkflowInstanceCreator/CreatePreStageInstance', { params: { workflowCode: this.workflowCode, subscriberNumber: <any>this.subscriberNumber } })
      .subscribe(result => {
        if (result.version != -99) {
          this.preStageRoot = result;
          this.preStageForm = result?.stepPreStage;
          this.preStageForm = this.preStageRoot?.stepPreStage;
          this.preStageForm.preStageInfo.subscriberMotiveDescServ = null;
          this.workflowInstanceId = this.preStageForm?.preStageInfo?.instance;
          this.calculateCurrentPrestageServiceScenario();
          this.populateAndFormatSubscriberServicesList();
          this.loadMotivosDropdown();


          if ((this.workflowCode.indexOf('PEDI008') > -1 || this.workflowCode.indexOf('PEDI005') > -1) && this.isService
          ) {
            this.isAllowPersonalData = this.preStageForm.preStageInfo.allowPersonalData == "S" ? true : false;
            this.currentStep = 98;
          }
          else {
            this.currentStep = 1;
            this.preStageStep = 1;
          }
        } else {

          let modal = <models.BaseModalVM>{
            isError: true, //result.stateCode == 'ER' ? true : false,
            message: result.stepPreStage.preStageInfo.serviceFinal,
            param: null,
            cancelButton: {
              hideButton: true,
              buttonText: "Ok",
              buttonClass: 'btn-primary',
              iconClass: "icon-check"
            }
          };
          this.modalS.showModals([modal]);


        }
        this.loadingMaskService.setShowLoading(false);
      },
        error => {
          if (error == "subscriberNumberError") {
            let data: any;
            data = { 'subscriberNumber': this.subscriberNumber};

            let modal = <models.BaseModalVM>{
              isError: true, //result.stateCode == 'ER' ? true : false,
              message: "O número de subscritor é inválido!",
              param: data,
              cancelButton: {
                hideButton: true,
                buttonText: "Ok",
                buttonClass: 'btn-primary',
                iconClass: "icon-check"
              }
            };
            this.modalS.showModals([modal]);

          }
          this.loadingMaskService.setShowLoading(false);
        }
    );
  }

  calculateCurrentPrestageServiceScenario() {
    //cenario 1
    if (this.preStageForm.exSubscritorServicoSugerido.estado == 'A' && (this.preStageForm.exSubscritorServicoSugerido.servIntegracoesList == null || this.preStageForm.exSubscritorServicoSugerido.servIntegracoesList.length == 0)) {
      this.currentServiceScenario = this.Scenarios.Ativo;
    }
    //cenario 2
    if (this.preStageForm.exSubscritorServicoSugerido.estado == 'D' && (this.preStageForm.exSubscritorServicoSugerido.servIntegracoesList == null || this.preStageForm.exSubscritorServicoSugerido.servIntegracoesList.length == 0)) {
      this.currentServiceScenario = this.Scenarios.InativoNaoIntegrado;
    }
    //cenario 3
    if (this.preStageForm.exSubscritorServicoSugerido.estado == 'D' && (this.preStageForm.exSubscritorServicoSugerido.servIntegracoesList != null && this.preStageForm.exSubscritorServicoSugerido.servIntegracoesList.length > 0)) {
      this.currentServiceScenario = this.Scenarios.InativoIntegrado;
    }

    var flattenVinculos = this.flattenListaVinculos(this.preStageForm.exSubscritorServicoSugerido.servIntegracoesList);
    //cenario 4
    if (this.preStageForm.exSubscritorServicoSugerido.estado == 'A' && flattenVinculos.every(vinc => vinc.estado == 'D')) {
      this.currentServiceScenario = this.Scenarios.AtivoIntegradoExtinto;
    }
    //cenario 5
    //basta ter 1 A
    if (this.preStageForm.exSubscritorServicoSugerido.estado == 'A' && flattenVinculos.some(vinc => vinc.estado == 'A')) {
      this.currentServiceScenario = this.Scenarios.AtivoIntegradoAtivo;
    }

    //cenario 6
      if (this.preStageForm.exSubscritorServicoSugerido.estado == 'A' &&
        (
          (this.preStageForm.exSubscritorServicoSugerido.numSubsAtivos == "0" && this.preStageForm.exSubscritorServicoSugerido.registadoCGADIR == "0")
          ||
          (this.preStageForm.exSubscritorServicoSugerido.numSubsAtivos == "0")
          ||
          (this.preStageForm.exSubscritorServicoSugerido.registadoCGADIR == "0")
        )
      ) {
      this.currentServiceScenario = this.Scenarios.NaoInscritoOuSemSubsAtivos;
    }

    if (this.currentServiceScenario !== this.Scenarios.Ativo
      && this.currentServiceScenario !== this.Scenarios.AtivoIntegradoExtinto
      && this.currentServiceScenario !== this.Scenarios.AtivoIntegradoAtivo &&
      !this.isAtendimento && !this.isService) {
      const serviceFinalTemp = parseInt(this.preStageForm.preStageInfo.serviceFinal);
      if (serviceFinalTemp == 0) {
        this.respostaExSubscritor = false;
        this.preStageForm.preStageInfo.serviceFinal = "0";
        this.preStageForm.preStageInfo.acceptPreselect = "false";
        
        this.childWorkflow = null;
        this.choosenVinculoReset = false;
      }

    }
    else {
      this.respostaExSubscritor = this.preStageForm.preStageInfo.acceptPreselect != null && this.preStageForm.preStageInfo.acceptPreselect != "" ? this.preStageForm.preStageInfo.acceptPreselect == 'true' : null;      
      
    }
  }


  flattenListaVinculos(vinculos: models.VinculoServicoVM[]) : models.VinculoServicoVM[]{
    var flattenVinculos: models.VinculoServicoVM[] = []
    vinculos?.forEach(vinculo => {
      flattenVinculos = [...flattenVinculos, vinculo, ...this.flattenListaVinculos(vinculo.servIntegracoesList)]
    })

    return flattenVinculos;
  }


  onConcordaChange(concordaAnswer: any) {
    if (concordaAnswer.target.value == "true") {
      this.respostaExSubscritor = true;
      this.preStageForm.preStageInfo.serviceFinal = this.preStageForm.exSubscritorServicoSugerido.chaveServico;
      this.preStageForm.preStageInfo.acceptPreselect = "true";
      this.choosenVinculoReset = true;
    } else {
      this.respostaExSubscritor = false;
      this.preStageForm.preStageInfo.serviceFinal = "0";
      this.finalService = null; //
      this.preStageForm.preStageInfo.acceptPreselect = "false";

      this.childWorkflow = null;
      this.choosenVinculoReset = false;
    }
  }

  public getDesignacaoServicoEscolhido: any = (chaveServico: string) => {
    return [this.preStageForm.exSubscritorServicoSugerido, ...this.subscriberServices].find(el => el.chaveServico == chaveServico).designacao
  };


  onSelectionVinculoChange(event: VinculosAndIndexVM) {
    this.finalService = event.vinculo;
    this.preStageForm.preStageInfo.serviceFinal = event.vinculo.chaveServico;
    this.preStageForm.preStageInfo.serviceFinalIntegracao = event.vinculo.servInicialChave;
    if (this.finalService.chaveServico != '000' && this.finalService.chaveServico != "-1") {
      this.documentsList = [];
    }
  }

  public onDocumentsListChanged(newDocumentList: DocumentVMExtension[]) {
    this.documentsList = newDocumentList;
    if (this.verifyPreStageDocumentsList(newDocumentList)) {
      this.savePreStageInstance(false, null, true);
    } else {
      this.cgaSubmitedDocuments = false;
    }
  }

  expandRow(entry: models.VinculoServicoVM, selectedRow: number) {
    if (entry.estado != "A") {
      if (this.expandedRowIndex != selectedRow) {
        this.expandedRowIndex = selectedRow;
      } else {
        this.expandedRowIndex = null;
      }


    } else {
      this.expandedRowIndex = null;
    }
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  // #endregion EXSUBSCRITORES
}
